import React from "react"
import { Link } from "gatsby"
import SkillFactoryImg from "../../images/skill-factory.svg"

const SkillFactory = () => {
  return (
    <section className="bg-primary text-white">
      <div className="flex flex-col-reverse md:flex-row container mx-auto px-6 pb-8 items-center">
        <div className="w-full md:w-3/5">
          <h3 className="text-5xl pb-4 font-normal leading-tight">
            <span className="text-secondary font-bold">Skill</span> Factory
          </h3>
          <p className="pb-8 text-xl">
          This is the <b>learning Framework</b> where we offer a study program coordinated by our <b>Skill Factory Lead.</b>
          </p>
          <Link
            to="/careers/skill-factory"
            title="Get in touch"
            className="mx-auto lg:mr-5 lg:mx-0 my-8 hover:text-white border-white border-solid border-2 hover:bg-secondary hover:text-variant btn"
          >
            Know us 
          </Link>
        </div>
        <div className="w-full md:w-2/5 flex flex-col justify-items-center">
          <div className="bg-secondary btn mx-auto">Si recién comenzás</div>
          <img
            src={SkillFactoryImg}
            alt="SkillFactory"
            className="hidden md:block mx-auto"
            width="200"
          />
        </div>
      </div>
    </section>
  )
}

export default SkillFactory
